module.exports = __webpack_public_path__ + "img/32-heatstroke-fr.88440e84.svg";